import { RESET_CERTIFICATE, GET_CERTIFICATE_SUCCESS, GET_CERTIFICATE_FAIL, GET_CERTIFICATE, SET_CERTIFICATE } from '../constants';
export function reset() {
  return {
    type: RESET_CERTIFICATE
  };
}
export function getCert(code) {
  return {
    types: [GET_CERTIFICATE, GET_CERTIFICATE_SUCCESS, GET_CERTIFICATE_FAIL],
    promise: function promise(fetch) {
      return fetch("/api/certificates/by-code/".concat(code), {
        method: 'GET'
      });
    }
  };
}
export function setCert(cert) {
  return {
    type: SET_CERTIFICATE,
    cert: cert
  };
}